import { Box } from '@mui/material';
import { CURRENCY } from '../../../../config/appConfig';
import { DateHelper } from '../../../../helpers/dateHelper';
import { currencyFormatterHelper } from '../../../../helpers/currencyFormatterHelper';

export const InitializeColumns = (
	totalDeposits = 0,
	totalInvestments = 0,
	totalReserved = 0,
	totalRepayment = 0,
	totalEarnings = 0,
	totalFees = 0,
	totalLoses = 0,
	totalWithdrawals = 0,
	t
) => {
	return [
		{
			header: t('date'),
			accessorKey: 'date',
			maxSize: 40,
			size: 40,
			enablePinning: true,
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'MMM dd, yyyy');
			},
			Footer: () => <Box>Total</Box>,
		},
		{
			header: t('openingBalance'),
			accessorKey: 'openingBalance',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
		},
		{
			header: t('deposits'),
			accessorKey: 'deposits',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalDeposits?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},
		{
			header: t('investments'),
			accessorKey: 'investments',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalInvestments?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},
		{
			header: t('reserved'),
			accessorKey: 'reserved',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalReserved?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},
		{
			header: t('repayments'),
			accessorKey: 'repayment',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalRepayment?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},
		{
			header: t('earnings'),
			accessorKey: 'earnings',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalEarnings?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},
		{
			header: t('fees'),
			accessorKey: 'fees',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalFees?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},
		{
			header: t('loses'),
			accessorKey: 'loses',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalLoses?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},

		{
			header: t('withdrawals'),
			accessorKey: 'withdrawals',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
			Footer: () => (
				<Box className="currency-symbol">
					{totalWithdrawals?.toLocaleString?.('en-US', {
						style: 'currency',
						currency: CURRENCY,
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}) || 0}
				</Box>
			),
		},
		{
			header: t('closingBalance'),
			accessorKey: 'closingBalance',

			maxSize: 40,
			size: 40,
			Cell: ({ cell }) => {
				return (
					<Box className="text-center">
						{currencyFormatterHelper(cell?.getValue())}
					</Box>
				);
			},
		},
	];
};
